module.exports = __webpack_public_path__ + "static/media/2.05b66505.JPG";